<!-- 上传 -->
<template>
  <div class="uploadBox">
    <el-upload
      drag
      :accept="(uploadData.accept.join(','))||'.doc,.docx'"
      action="none"
      :on-remove="handleRemove"
      :on-change="handleChange"
      :file-list="fileList"
      :limit="1"
      :auto-upload="false"
      ref="upload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        只能上传符合条件的{{ (uploadData.accept.join(',')) }}模板
      </div>
    </el-upload>
    <div class="box">
      <el-button
        v-if="uploadData.isHaveExportTemBtn"
        type="primary"
        :loading="isExportLoadingTem"
        @click="handleClickExportTem"
        >导出数据模板</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    uploadData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fileList: [],
      isExportLoading: false,
      isExportLoadingTem: false,
    };
  },
  methods: {
    //点击清除上传文件
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    //预上传文件回调，判断文件格式是否符合，符合则push到上传文件数组，否则提醒并清空上传文件数组
    handleChange(file, fileList) {
      this.fileList.push(file);
      if (!this.isExtension(file.name)) this.fileList = [];
    },
    //判断文件格式是否符合
    isExtension(fileName, flag = true) {
      let suffix = fileName.substring(fileName.lastIndexOf(".") + 1);
      const extension = this.uploadData.accept&&this.uploadData.accept.map(item=>item.replace('.','')).includes(suffix);
      if (!extension) {
        this.$message({
          message: `上传文件只能是${(this.uploadData.accept&&this.uploadData.accept.join(','))||'.doc,.docx'}格式!`,
          type: "info",
        });
        flag = false;
      }
      return flag;
    },
    //点击数据更新dialog中导出数据
    // handleClickExport() {
    //   this.$dialog.exportConfirm("确认导出客户数据吗？").then(() => {
    //     let ids = "";
    //     if (this.tableData.selectedRows.length) {
    //       let arr = this.tableData.selectedRows.map((item) => item.id);
    //       ids = arr.join(",");
    //     }
    //     this.isExportLoading = true;
    //     this.uploadData.exportExcelApi({ obj: this.searchForm, ids })
    //       .then((res) => {
    //         // blobAndExcelDownload(res.data, "导出客户数据.xlsx");
    //         this.$message({ type: "success", message: res });
    //       })
    //       .catch((err) => {
    //         this.$message({ type: "error", message: err.message });
    //       })
    //       .finally(() => {
    //         this.isExportLoading = false;
    //       });
    //   });
    // },
    //点击数据更新dialog中导出数据模板
    handleClickExportTem() {
      this.$dialog
        .exportConfirm("确认导出数据模板吗？")
        .then(() => {
          this.isExportLoadingTem = true;
          let a = document.createElement("a");
          a.href = this.uploadData.temUrl||"/template.xlsx";
          //路径中'/'为根目录，即index.html所在的目录
          a.download = this.uploadData.temName||"xx.xlsx";
          a.click();
          // window.open('http://localhost:8080/RiskBaseData.xls')
          this.isExportLoadingTem = false;
          // this.uploadData.exportExcelTemApi().then((res) => {
          //   blobAndExcelDownload(res.data, "导出客户数据模板.xlsx");
          //   // this.$message({type:'success',message:res})
          // }).catch(err=>{
          //   this.$message({type:'error',message:err.message})
          // }).finally(()=>{
          //   this.isExportLoadingTem=false
          // })
        })
        .catch(() => {});
    },
  },
};
</script>